module.exports = __webpack_public_path__ + "img/locationInfo.021c579a.svg";